/**
 * Created by Mark on 21/04/2017.
 */
/**
 * Created by Mark on 04/04/2017.
 */


import React from "react";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6
import CDNImage from './media/image.js';
import MedalGraphic from './media/medal.image.js';
import {FormattedDate , FormattedTime , FormattedMessage}  from 'react-intl';
import InternationalTranslation from '../store/internationalization-store.js';
import Tests from '../classes/tests.js'
import { OverlayTrigger , Tooltip , Button , Modal } from 'react-bootstrap';
import Data from '../classes/date.js';
const getMedalTranslation = function(score){

    if(Number(score) < 50) return  InternationalTranslation.getTranslation('ui-999999' , 'no')
    if(Number(score) < 70) return  InternationalTranslation.getTranslation('ui-812' , 'bronze')
    if(Number(score) < 90) return  InternationalTranslation.getTranslation('ui-811' , 'silver')

    return InternationalTranslation.getTranslation('ui-810' , 'gold')
}

export default class ActivityList extends React.Component {

    constructor(props){
        super();
        this.state = {
            data:props.data || [],
            limit: props.limit || 7,
            hideLoad:false,
        }
    }

    componentWillReceiveProps(props){
        this.setState({data:props.data})
    }

    renderLoginItem(letter , name , date){
        return (
            <div key={"letter-"+name+Math.random()} className="list-group-item media">
                <div className="checkbox pull-left lgi-checkbox">
                    <div className="pull-left">
                        <div className="avatar-char palette-Light-Blue bg">{letter}</div>
                    </div>

                    <div className="media-body p-l-5">
                        <div className="lgi-heading">{name}
                            <small>
                                {(new Data()).format(date)}
                            </small>
                        </div>
                        <small className="lgi-text"> <FormattedMessage
                            id="5025"
                            defaultMessage="{name} has logged into the resources"
                            values={{name: String(name) }}
                            /></small>
                    </div>
                </div>
            </div>)
    }

    renderGameItem(picture , name , date , percentage , score , moduleName , game_translation , ietf , type){

        let message = "";
        let translationID = (new Tests()).getSkillTranslationGraphic(type);

        if(Number(score) <= 0)
        {
            message = <FormattedMessage id="ui-2130" defaultMessage="{username} just completed this activity, but didn't win any points." values={{username: String(name) }}/>
        }
        else
        {
            message = <FormattedMessage id="ui-802" defaultMessage="{username} just won {pionts} points" values={{pionts:String(score) , username: String(name) }}/>
        }

        return (
            <div key={"test-letter-"+name+Math.random()} className="list-group-item media">
                <div className="checkbox pull-left lgi-checkbox">
                         <div className="pull-left">
                               <img className="avatar-img" src={"img/flags/"+ietf+".png"} alt=""/>
                        </div>

                    <div className="media-body p-l-5">
                        <div className="lgi-heading">{moduleName}
                            <small>
                                <b><FormattedMessage id={ 'ui-'+game_translation } defaultMessage={ 'Chat' }/></b> -
                                {(new Data()).format(date)}
                            </small>
                        </div>
                        <small className="lgi-text">
                            {message}
                        </small>
                    </div>


                </div>

                <span className="p-5 badge palette-Branding secondary bg">
                    <FormattedMessage id={ translationID } defaultMessage={ '' }/>
                </span>
                  <span className="p-5 badge palette-Branding secondary bg">
                    <FormattedMessage id={ 'ui-87' } defaultMessage={ 'Chat' }/>
                </span>
            </div>)
    }

    renderTestItem(type , name , date , percentage , score , moduleName , ietf){

        let testPath = (new Tests()).getSkillGraphic(type);
        let translationID = (new Tests()).getSkillTranslationGraphic(type);

        let message = "";

        if(Number(percentage) < 50)
        {
            message = <FormattedMessage id="ui-2131" defaultMessage="{username} just completed this activity, but didn't win a medal." values={{username: String(name) }}/>
        }
        else
        {
            message = <FormattedMessage id="ui-801" defaultMessage="{username} just won a {medal_type} medal" values={{medal_type:String(getMedalTranslation(percentage)) , username: String(name) }}/>
        }

        return (
            <div key={"test-letter-"+name+Math.random()} className="list-group-item media">
                <div className="checkbox pull-left lgi-checkbox">
                    <div className="pull-left">
                        <img className="avatar-img" src={"img/flags/"+ietf+".png"} alt=""/>
                    </div>
                     <div className="media-body p-l-5">
                        <div className="lgi-heading">{moduleName}
                            <small>
                                <b><FormattedMessage id={ translationID } defaultMessage={ '' }/></b> -
                                {(new Data()).format(date)}
                            </small>
                        </div>
                        <small className="lgi-text">
                            {message}
                        </small>
                    </div>


                </div>
                <span className="p-5 badge palette-Branding secondary bg">
                    <FormattedMessage id={ 'ui-114' } defaultMessage={ 'Chat' }/>
                </span>
                <span className="p-0 badge remove-background"><MedalGraphic size={25} score={percentage} /></span>
            </div>)
    }

    renderHomeworkItem(type , name , date , percentage , score , moduleName){

        let testPath = (new Tests()).getSkillGraphic(type);
        let translationID = (new Tests()).getSkillTranslationGraphic(type);
        return (
            <div key={"test-letter-"+name+Math.random()} className="list-group-item media">
                <div className="checkbox pull-left lgi-checkbox">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip"><FormattedMessage id={ translationID } defaultMessage={ '' }/></Tooltip>}>
                        <div className="pull-left">
                            <CDNImage size={40}  className="media-object" src={testPath} alt=""></CDNImage>
                        </div>
                    </OverlayTrigger>
                    <div className="media-body p-l-5">
                        <div className="lgi-heading">{moduleName}
                            <small>
                                {(new Data()).format(date)}
                            </small>
                        </div>
                        <small className="lgi-text">
                            <FormattedMessage id="ui-801" defaultMessage="{username} just won a {medal_type} medal" values={{medal_type:String(getMedalTranslation(percentage)) , username: String(name) }}/>
                        </small>
                    </div>
                </div>
            </div>)
    }

    renderVerbItem(picture , name , date , percentage , score , moduleName , game_translation , ietf , type){

        let message = "";
        let translationID = (new Tests()).getSkillTranslationGraphic(type);

        if(Number(score) <= 0)
        {
            message = <FormattedMessage id="ui-2130" defaultMessage="{username} just completed this activity, but didn't win any points." values={{username: String(name) }}/>
        }
        else
        {
            message = <FormattedMessage id="ui-802" defaultMessage="{username} just won {pionts} points" values={{pionts:String(score) , username: String(name) }}/>
        }

        return (
            <div key={"test-letter-"+name+Math.random()} className="list-group-item media">
                <div className="checkbox pull-left lgi-checkbox">
                    <div className="pull-left">
                        <img className="avatar-img" src={"img/flags/"+ietf+".png"} alt=""/>
                    </div>

                    <div className="media-body p-l-5">
                        <div className="lgi-heading">{moduleName}
                            <small>
                                <b><FormattedMessage id={ 'ui-'+game_translation } defaultMessage={ 'Chat' }/></b> -
                                {(new Data()).format(date)}
                            </small>
                        </div>
                        <small className="lgi-text">
                            {message}
                        </small>
                    </div>


                </div>

                <span className="p-5 badge palette-Branding secondary bg">
                    <FormattedMessage id={ 'ui-1026' } defaultMessage={ '' }/>
                </span>

            </div>)
    }

    renderSentenceItem(picture , name , date , percentage , score , moduleName , game_translation , ietf , type){

        let message = "";
        let translationID = (new Tests()).getSkillTranslationGraphic(type);

        if(Number(score) <= 0)
        {
            message = <FormattedMessage id="ui-2130" defaultMessage="{username} just completed this activity, but didn't win any points." values={{username: String(name) }}/>
        }
        else
        {
            message = <FormattedMessage id="ui-802" defaultMessage="{username} just won {pionts} points" values={{pionts:String(score) , username: String(name) }}/>
        }

        return (
            <div key={"test-letter-"+name+Math.random()} className="list-group-item media">
                <div className="checkbox pull-left lgi-checkbox">
                    <div className="pull-left">
                        <img className="avatar-img" src={"img/flags/"+ietf+".png"} alt=""/>
                    </div>

                    <div className="media-body p-l-5">
                        <div className="lgi-heading">{moduleName}
                            <small>
                                <b><FormattedMessage id={ 'ui-'+game_translation } defaultMessage={ 'Chat' }/></b> -
                                {(new Data()).format(date)}
                            </small>
                        </div>
                        <small className="lgi-text">
                            {message}
                        </small>
                    </div>


                </div>

                <span className="p-5 badge palette-Branding secondary bg">
                    <FormattedMessage id={ 'ui-89' } defaultMessage={ '' }/>
                </span>

            </div>)
    }

    renderGrammerItem(picture , name , date , percentage , score , moduleName , game_translation , ietf , type){

        let message = "";
        let translationID = (new Tests()).getSkillTranslationGraphic(type);

        if(Number(score) <= 0)
        {
            message = <FormattedMessage id="ui-2130" defaultMessage="{username} just completed this activity, but didn't win any points." values={{username: String(name) }}/>
        }
        else
        {
            message = <FormattedMessage id="ui-802" defaultMessage="{username} just won {pionts} points" values={{pionts:String(score) , username: String(name) }}/>
        }

        return (
            <div key={"test-letter-"+name+Math.random()} className="list-group-item media">
                <div className="checkbox pull-left lgi-checkbox">
                    <div className="pull-left">
                        <img className="avatar-img" src={"img/flags/"+ietf+".png"} alt=""/>
                    </div>

                    <div className="media-body p-l-5">
                        <div className="lgi-heading">{moduleName}
                            <small>
                                <b><FormattedMessage id={ 'ui-'+game_translation } defaultMessage={ 'Chat' }/></b> -
                                {(new Data()).format(date)}
                            </small>
                        </div>
                        <small className="lgi-text">
                            {message}
                        </small>
                    </div>


                </div>

                <span className="p-5 badge palette-Branding secondary bg">
                    <FormattedMessage id={ 'ui-100' } defaultMessage={ '' }/>
                </span>

            </div>)
    }

    renderItem(object){

        switch(object.type)
        {
            case "login": return this.renderLoginItem(object.name[0] , object.name , object['date_time']);
            case "game":
                if(object.is_test == 1) return this.renderTestItem(object.skill , object.name ,  object['date_time'] , object['precentage'] , object['score'] , InternationalTranslation.getModuleNoIndexTranslation(object.module_uid) , object.ietf);
                else return this.renderGameItem(object.graphic , object.name ,  object['date_time'] , object['precentage'] , object['score'] , InternationalTranslation.getModuleNoIndexTranslation(object.module_uid) , object.game_translation ,object.ietf , object.skill);
                return null;
            case "verb":
                if(object.is_test == 1) return this.renderTestItem(object.skill , object.name ,  object['date_time'] , object['precentage'] , object['score'] , object.title , object.ietf);
                else return this.renderVerbItem(object.graphic , object.name ,  object['date_time'] , object['precentage'] , object['score'] , object.title , object.game_translation ,object.ietf , object.skill);
                return null;
            case "sentence":
                if(object.is_test == 1) return this.renderTestItem(object.skill , object.name ,  object['date_time'] , object['precentage'] , object['score'] , object.title , object.ietf);
                else return this.renderSentenceItem(object.graphic , object.name ,  object['date_time'] , object['precentage'] , object['score'] , InternationalTranslation.getModuleNoIndexTranslation(object.title) , object.game_translation ,object.ietf , object.skill);
                return null;
            case "grammer":
                if(object.is_test == 1) return this.renderTestItem(object.skill , object.name ,  object['date_time'] , object['precentage'] , object['score'] , object.title , object.ietf);
                else return this.renderGrammerItem(object.graphic , object.name ,  object['date_time'] , object['precentage'] , object['score'] , InternationalTranslation.getModuleNoIndexTranslation(object.title) , object.game_translation ,object.ietf , object.skill);
                return null;
            case "homework":
                return this.renderHomeworkItem(object.skill , object.name ,  object['date_time'] , object['precentage'] , object['score'] , object.homework_name);
        }

        return null;
    }

    renderItems(){
        var items = [];

        var limit = this.state.data.length > this.state.limit ? this.state.limit : this.state.data.length;
        for(var idx = 0 ; idx < limit; idx++)
        {
            items.push(this.renderItem(this.state.data[idx]));
        }

        return items;
    }

    removeLimit(){
        this.setState({limit:60 , hideLoad:true});
    }

    render(){
        return ( <div className="list-group lg-alt lg-even-black">`
                    {this.renderItems()}
                    <div className={this.state.hideLoad ? "hide" : "load-more m-t-30 p-b-30"}>
                        <a onClick={this.removeLimit.bind(this)}className="palette-Branding secondary bg palette-White text" >
                            <span className="palette-White text">
                                <i className="zmdi zmdi-refresh-alt"></i> <FormattedMessage id={ 'ui-631' } defaultMessage={ 'Next' }/>
                            </span>
                        </a>
                    </div>
                </div> );
    }
}


// WEBPACK FOOTER //
// ./src/components/activity-widget.js